import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="totp-verification"
export default class extends Controller {
  static targets = ["submitButton"]
  
  connect() {
    // Auto-submit when 6 digits are entered
    this.otpController = this.application.getControllerForElementAndIdentifier(
      this.element.querySelector('[data-controller*="otp-input"]'), 
      'otp-input'
    )
    
    if (this.otpController) {
      this.otpController.element.addEventListener('otp:complete', this.handleOtpComplete.bind(this))
    }
  }

  disconnect() {
    if (this.otpController) {
      this.otpController.element.removeEventListener('otp:complete', this.handleOtpComplete.bind(this))
    }
  }

  handleOtpComplete(event) {
    // Auto-submit when 6 digits are entered
    const form = this.element.closest('form')
    if (form && event.detail.code.length === 6) {
      // Small delay to show the complete input before submitting
      setTimeout(() => {
        this.submitButtonTarget.disabled = true
        form.submit()
      }, 200)
    }
  }
}
